export class CalcRequestModel {
//   public calc: Calc;
//
//   constructor() {
//     this.calc = new Calc();
//   }
// }
//
// export class Calc {
  /*
  public StatNr: number;
  public Branche: number;
  public Duration: number;
  public PremiumPaymentDuration: number;
  public OptimizeTarget: number;
  public OptimizeValue: number;
  public BeginningDate: string;
  public NumOfInstalments: number;
  public Index: number;

  public Medical_Examination_IP1: number;
  public Gender_IP1: number;
  public Age_IP1: number;

  public Medical_Examination_IP2: number;
  public Gender_IP2: number;
  public Age_IP2: number;

  public Variant_1: number;
  public Variant_2: number;
  public Variant_3: number;
  public Variant_4: number;
  public Variant_5: number;
  */
  public DatumPocetka: string;
  public IndexUkljucen: number;
  public NacinPlacanja: number;
  public Pol: number;
  public Godiste: number;
  public Trajanje: number;
  public VrstaIzracuna: number;
  public Iznos: number;
  public RDZOsiguranaSuma: number;
  public UI: number;
  public AUZUkljucen: number;
  public Tarifa: number;
  public Pol2: number;
  public Godiste2: number;
  public HIOs: number;
  public UserId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/calc-request.model.ts